import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pendingCandCanApprovalCount: 0,
  pendingCandApprovalCount: 0,
  pendingMasterDataCount: 0,

  totalPendingApprvlCount: 0,
  totalPendingCandApprvlCount: 0,

  // this is static data , not backend sync
  pendingMaterialCount: 0,
  pendingPurchaseCount: 0,
};

export const fetchApprovalCounts = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { isAuthenticated, user } = state.auth || {};

    if (!isAuthenticated || !user?.userId) {
      return;
    }

    const token = sessionStorage.getItem('token');
    
    // import dynamically to avoid circular dependencies if needed, but standard import is fine
    // since we need fetchEncryptedToken and axiosInstance,
    const { fetchEncryptedToken } = await import('src/utils/encryptUtils');
    const axiosInstance = (await import('src/api/axiosInstance')).default;

    const encryptedId = await fetchEncryptedToken(user.userId, token);

    if (!encryptedId) return;

    const response = await axiosInstance.get(
      `/rest/dashboard1/approval-count/${encryptedId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data || {};

    dispatch(pendingCountsSlice.actions.setAllApprovalCounts(data));

  } catch (error) {
    console.error('Error fetching approval counts:', error);
    // Keep previous counts on transient failures to avoid flickering/incorrect zero badges.
  }
};

const pendingCountsSlice = createSlice({
  name: 'pendingCounts',
  initialState,
  reducers: {
    setAllApprovalCounts(state, action) {
      const data = action.payload || {};
      
      state.pendingCandCanApprovalCount = data.cancellationRequisitionCount || 0;
      state.pendingCandApprovalCount = data.candidateRequisitionApprovalCount || 0;
      state.pendingMasterDataCount = data.masterDataPendingCount || 0;
      
      // Defaults (future support)
      state.pendingMaterialCount = data.materialCount || 0;
      state.pendingPurchaseCount = data.purchaseCount || 0;

      // Unanimous calculation for totals
      state.totalPendingApprvlCount =
        state.pendingCandCanApprovalCount +
        state.pendingCandApprovalCount +
        state.pendingMasterDataCount +
        state.pendingPurchaseCount +
        state.pendingMaterialCount;
        
      state.totalPendingCandApprvlCount =
        state.pendingCandApprovalCount + state.pendingCandCanApprovalCount;
    },

    setPendingMaterialCount(state, action) {
      state.pendingMaterialCount = action.payload;

      state.totalPendingApprvlCount =
        state.pendingCandCanApprovalCount +
        state.pendingCandApprovalCount +
        state.pendingMasterDataCount +
        state.pendingPurchaseCount +
        state.pendingMaterialCount ;
    },
    setPendingPurchaseCount(state, action) {
      state.pendingPurchaseCount = action.payload;
      state.totalPendingApprvlCount =
        state.pendingMaterialCount +
        state.pendingCandCanApprovalCount +
        state.pendingCandApprovalCount +
        state.pendingPurchaseCount +
        state.pendingMasterDataCount;
    },
  },
});
export const {
  setPendingMaterialCount,
  setPendingPurchaseCount,
} = pendingCountsSlice.actions;

export default pendingCountsSlice.reducer;
